module.exports = __webpack_public_path__ + "static/media/page-15.770fc2a3.png";